import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

const LOAN_PURPOSE_OPTIONS = [
  {
    displayValue: 'Debt Consolidation',
    id: 'loanPurpose',
    value: 'debt_consolidation'
  },
  {
    displayValue: 'Home Improvements',
    id: 'loanPurpose',
    value: 'home_improvements'
  },
  {
    displayValue: 'Car Repair',
    id: 'loanPurpose',
    value: 'car_repair'
  },
  {
    displayValue: 'Emergency Expense',
    id: 'loanPurpose',
    value: 'emergency_expense'
  },
  {
    displayValue: 'Other',
    id: 'loanPurpose',
    value: 'other'
  }
];

export default {
  defaultNextPage: 'page-4',
  content: [
    configureProgressBar(9),
    configureTitle(['What is the purpose of this loan? ', '(Optional)']),
    {
      component: ButtonGroup,
      name: 'loanPurpose',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'loanPurpose',
        direction: 'column',
        options: LOAN_PURPOSE_OPTIONS
      }
    },
    nextButtonConfig('page-3.1')
  ]
};
